import React from "react";
import StatusPage from "./StatusPage";
import { SearchIcon } from "../../components/common/Icons/Icons";

const NotFound = () => (
    <StatusPage
        code="404"
        title="Page not found"
        message="The page you're looking for doesn't exist or has moved."
        icon={<SearchIcon/>}
    />
);

export default NotFound;
